module.exports = __webpack_public_path__ + "img/title.866606bb.png";